import api from "../hooks/api";
import { API_URLS } from "../App";
import { CampaignAssignment } from "../model/Campaign";

/** Admin-only: active campaigns currently serving a compound. GET only. */
export async function fetchCompoundActiveCampaigns(
  compoundId: string,
): Promise<CampaignAssignment[]> {
  const response = await api.get(
    `${API_URLS.COMPOUNDS}/${encodeURIComponent(compoundId)}/campaigns`,
  );
  return response.data as CampaignAssignment[];
}
